import React, {useState, useEffect, useRef} from 'react';
import { useParams } from 'react-router';
import {Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../config.js';

import { alertService } from '../services/alert.service.js';
import TagInfo from '../components/tagInfo.js';
import Progress from '../components/progress.js';
import ImagePicker from '../components/imagePicker.js';

function Tag(props) {
  const { id } = useParams();
  const [tag, setTag] = useState({});
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(()=>{
    axios.get(global.config.api_server+'tag?id='+id+'&token='+localStorage.getItem("token")) 
    .then(res => {
      if(res.status === 200 && res.data.status === "success"){
        const currentTag = res.data.tag;
        if(currentTag === null || currentTag === undefined){
          navigate("/tags");
        }else{
          setTag(currentTag);
          setLoading(false);
        }
      }else{
        alertService.error(res.data.error);
      }
    }).catch(err => {
      alertService.error(err);
      navigate("/tags");
    });
  }, []);
  
  const handleDelete = (event) => {
    event.preventDefault();
    if(id){
      axios.get(global.config.api_server+'tag?&id='+id+'&token='+localStorage.getItem("token")+'&task=delete').then(res => {
        if(res.status === 200 && res.data.status === "success"){
          alertService.success('Tag deleted');
          navigate("/tags");
        }else{
          alertService.error(res.data.error);
        }
      }).catch(err => {
        alertService.error(err);
      });
    }else{
      alertService.error('Tag ID not found');
    }
  }
  
  let deleteButton = "";
  if(parseInt(localStorage.getItem("role")) >= 5){
    deleteButton = <button className={'btn btn-icon-split float-right btn-danger'} data-toggle="modal" data-target="#deleteModal">
                    <span className="icon text-white-50">
                      <i className="fas fa-trash"></i>
                    </span>
                    <span className="text">Delete</span>
                  </button>;
  }

  if(loading){
    return <Progress/>;
  }else{
    return(
      <div className="container-fluid">
        <div className="mb-3">
          {deleteButton}
          <Link to={"/tags"} className="btn btn-light btn-icon-split mr-2">
            <span className="icon text-white-50">
              <i className="fas fa-arrow-left"></i>
            </span>
            <span className="text">Back</span>
          </Link>
        </div>
        
        <TagInfo id={id} tag={tag}/>
        <ImagePicker id={id} item={tag} type="TAG" limit={0}></ImagePicker>
        
        <div className="modal fade" id="deleteModal" tabIndex="-1" role="dialog" aria-labelledby="delete-popup" aria-hidden="true">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="delete-popup">Confirm deletion?</h5>
                <button className="close" type="button" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">Are you sure, you want to delete this tag?</div>
              <div className="modal-footer">
                <button className="btn btn-default" type="button" data-dismiss="modal">Cancel</button>
                <button className={'btn ml-3 btn-danger'} onClick={handleDelete} data-dismiss="modal">Delete</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Tag;